import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'

import Button from '@eig-builder/core-ui/Button'

import usePostAsJson from '@eig-builder/core-utils/hooks/usePostAsJson'

import { showSuccess } from '@eig-builder/module-notification-bar-with-context/actions'
import { NotificationBarContext } from '@eig-builder/module-notification-bar-with-context'

import { DataElementLocations } from '@eig-builder/core-utils/helpers/tagging-helper'

import ButtonWithLoader from 'core/components/button-with-loader'
import Modal from 'core/components/modal'

import { getCrmApiOptions } from 'modules/crm/helpers/fetch-options-helper'
import { refreshContent } from 'modules/crm/helpers/refresh-content-helper'

const ConvertToTestUser = ({ account, handleClose }) => {
  const [req, doConvert] = usePostAsJson()

  const dispatch = useDispatch()
  const { dispatch: notificationDispatch } = useContext(NotificationBarContext)
  const location = useLocation()

  useEffect(() => {
    if (req.isSuccess) {
      showSuccess(`The user has been converted to a test user`)(notificationDispatch)
      refreshContent(location, account, dispatch)
      handleClose()
    }
  }, [req.isSuccess])

  const submit = () => {
    const options = getCrmApiOptions(account, '/v1.0/account/convert_to_test_user')
    doConvert({}, options)
  }

  const actions = [
    <Button
      key='convert-to-test-user-cancel'
      color='secondary'
      disabled={req.isLoading}
      onClick={handleClose}
      dataElementLocation={DataElementLocations.BODY}
      dataElementLabel='cst-account-details-convert-to-test-user-cancel'
      dataElementId='cst-account-details-convert-to-test-user-cancel'
    >
      Cancel
    </Button>,
    <ButtonWithLoader
      key='convert-to-test-user-submit'
      type='submit'
      onClick={submit}
      dataElementSuffix='account-details--cconvert-to-test-user-submit'
      showLoader={req.isLoading}
      text='Convert to test user'
    />
  ]

  return <Modal
    actions={actions}
    dataElementPrefix='cst-user--convert-to-test-user'
    disableBackdropClick
    handleClose={handleClose}
    open
    title='Convert to test user'
  >
    This functionality is only for testing purposes! This will add test credits to the account that can be used to make payments in Production. Only possible for company email addresses and in case there is no other payment method yet.
  </Modal>
}

ConvertToTestUser.propTypes = {
  account: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired
}

export default ConvertToTestUser
